module.exports = __webpack_public_path__ + "img/hal.b5714e90.jpg";